<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="item in items" :key="item.id">
        <component
          :is="item.type"
          v-bind="item.props"
          @click.native="item.onclick(item.props, item)"
        >
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Swiper from 'swiper';
import Card from './Item';
import NewBooking from './NewBooking';


export default {
  components: { Card, NewBooking },

  data: () => ({
    swiper: null,
  }),

  mounted() {
    this.swiper = new Swiper('.swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      centeredSlides: true,
      allowTouchMove: false,
      on: {
        init: () => {
          this.$emit('init');
        },
      },
    });

    this.swiper.on('slideChange', () => {
      this.$emit('slideChange');
    });

    this.swiper.on('slideChangeTransitionStart', () => {
      this.$emit('transitionStart');
    });

    window.addEventListener('resize', () => {
      this.swiper.update();
    });

    setInterval(() => {
      this.goToCurrent();
    }, 30 * 1000);
  },

  updated() {
    this.swiper.update();
    this.$emit('updated');
  },

  computed: {
    activeSlideIndex() {
      return this.swiper.realIndex;
    },
  },

  props: {
    items: Array,
  },

  methods: {
    goTo(index) {
      this.swiper.slideTo(index);
    },

    next() {
      this.swiper.slideNext();
    },

    prev() {
      this.swiper.slidePrev();
    },

    goToCurrent() {
      // Scroll to booking within current hour
      const booking = this.items
        .map((val, index) => ({
          start: val.props.startDate
            // Subtract 30 mins since new booking card advances availability start by 30 minutes
            ? moment(val.props.startDate).subtract(30, 'minutes')
            : moment(val.props.booking.start_date),
          end: val.props.endDate
            ? moment(val.props.endDate)
            : moment(val.props.booking.end_date),
          index,
        }))
        .filter(({ start, end }) => moment().isBetween(start, end));
      if (booking.length) this.swiper.slideTo(booking[0].index);
    },
  },
};
</script>

<style lang="scss">
  .swiper-container {
    width: 100%;
    height: 100%;
    overflow: visible !important;

    .swiper-slide {
      width: 75%;
      opacity: 0.4;

      &-active {
        opacity: 1;
      }

      &-next, &-prev {
        > div {
          height: inherit;
          background-color:#eeeeee !important;
        }

        * { font-size: 0px !important; }

        &::before {
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          -webkit-font-smoothing: antialiased;
          font-family: "Font Awesome 5 Free"; font-weight: 900;
          position: absolute;
          display: flex;
          height: inherit;
          align-items: center;
          justify-content: center;
          font-size: 3rem;
        }
      }

      &-next {
        &::before {
          margin-left: 20px;
          content: "\f054";
        }
      }

      &-prev {
        &::before {
          margin-right: 20px;
          right: 0;
          content: "\f053";
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Booking/Card/ScrollableList.vue